/* Native navigation enhancement; the existing vehicle dialog owns selection and routing. */
(function () {
  'use strict';
  function createMobileVehiclePanel(win, doc) {
    const mobile = win.matchMedia('(max-width: 999px)');
    let slot, marker, current, opener, animation, generation = 0;
    const reduced = () => win.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function stop() { generation++; animation?.cancel(); animation = null; }
    function restore() {
      stop();
      if(opener?.matches?.('a,button'))opener.setAttribute('aria-expanded','false');
      if (current && marker?.parentNode) marker.parentNode.insertBefore(current, marker.nextSibling);
      current?.removeAttribute('data-fcs-mobile-panel');
      if (slot) slot.hidden = true;
    }
    function open(el) {
      const section = doc.querySelector('[data-section-type="header"]');
      const header = section?.closest('.shopify-section__header') || section;
      if (!mobile.matches || !header?.parentNode) return false;
      stop(); opener = doc.activeElement; current = el;
      if (!marker) { marker = doc.createComment('vehicle finder home'); el.parentNode.insertBefore(marker, el); }
      if (!slot) {
        slot = doc.createElement('div'); slot.className = 'fcs-mobile-vehicle-panel';
        slot.dataset.fcsMobileVehiclePanel = ''; slot.id = 'fcs-mobile-vehicle-panel'; slot.hidden = true;
        header.parentNode.insertBefore(slot, header.nextSibling);
        el.addEventListener('close', () => { if (el.open || !el.hasAttribute('data-fcs-mobile-panel')) return; restore(); if (opener?.isConnected) opener.focus({preventScroll:true}); });
      }
      slot.style.scrollMarginTop = header.getBoundingClientRect().height + 'px';
      if(opener?.matches?.('a,button')){opener.setAttribute('aria-controls',slot.id);opener.setAttribute('aria-expanded','true');}
      slot.hidden = false; slot.append(el); el.setAttribute('data-fcs-mobile-panel', '');
      if (!el.open) el.show();
      if (!reduced() && slot.animate) animation = slot.animate([{height:'0px',opacity:.5},{height:el.scrollHeight+'px',opacity:1}], {duration:220,easing:'cubic-bezier(.2,.7,.3,1)'});
      slot.scrollIntoView?.({block:'start',behavior:reduced()?'auto':'smooth'});
      return true;
    }
    function close(el) {
      if (el !== current || !el.hasAttribute('data-fcs-mobile-panel') || !el.open) return false;
      stop(); const ticket = generation;
      if (reduced() || !slot.animate) el.close();
      else {
        animation = slot.animate([{height:slot.getBoundingClientRect().height+'px',opacity:1},{height:'0px',opacity:.4}], {duration:180,easing:'ease-in',fill:'forwards'});
        animation.finished.then(() => { if (ticket === generation) el.close(); }).catch(() => {});
      }
      return true;
    }
    function install() {
      doc.addEventListener('keydown', event => {
        if (event.key === 'Escape' && current?.open && current.hasAttribute('data-fcs-mobile-panel')) { event.preventDefault(); close(current); }
      });
      mobile.addEventListener('change', () => {
        if (!current?.open) return;
        const el = current, focused = doc.activeElement;
        stop(); el.close(); restore();
        if (!open(el)) el.showModal();
        focused?.focus?.({preventScroll:true});
      });
    }
    return {open, close, install};
  }
  function createVehicleMenu(win, doc) {
    const scope = '[data-section-type="header"]';
    const links = scope + ' a[href]';
    const attached = new WeakSet();
    const animations = new WeakMap();
    let opener = null;
    const dialog = () => doc.querySelector('[data-fcs-vehicle-dialog]');
    const available = () => typeof win.FCSLiveFitment?.openChooser === 'function' && dialog();
    function menuLink(link) {
      if (!link?.closest?.(scope) || link.hasAttribute('download')) return false;
      try {
        const url = new URL(link.getAttribute('href'), win.location.href);
        return url.origin === win.location.origin && url.pathname === '/pages/vehicle-fit-guide';
      } catch (_) { return false; }
    }
    function normalClick(event, link) {
      return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey &&
        !event.shiftKey && !event.altKey && (!link.target || link.target === '_self');
    }
    function sync() {
      const el = available();
      if (!el) return;
      doc.querySelectorAll(links).forEach(link => {
        if (!menuLink(link)) return;
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-expanded', String(Boolean(el.open)));
      });
    }
    function reveal(node, duration = 200) {
      if (!node?.animate || win.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
      animations.get(node)?.cancel();
      const animation = node.animate([
        { clipPath: 'inset(0 0 12% 0)', opacity: 0.45, transform: 'translateY(-6px)' },
        { clipPath: 'inset(0 0 0 0)', opacity: 1, transform: 'translateY(0)' }
      ], { duration, easing: 'cubic-bezier(.2,.7,.3,1)' });
      animations.set(node, animation);
    }
    function attach(el) {
      if (attached.has(el)) return;
      attached.add(el);
      el.addEventListener('close', () => {
        sync();
        // Native mobile-menu closure precedes showModal, so return focus to its visible toggle.
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      });
      el.addEventListener('cancel', () => win.setTimeout(sync, 0));
      if (win.MutationObserver) new win.MutationObserver(records => {
        sync();
        if (!el.open) return;
        records.forEach(record => {
          if (record.type === 'attributes' && record.attributeName === 'disabled' &&
              record.target.matches('select') && !record.target.disabled) {
            reveal(record.target.closest('label'), 160);
          }
        });
      }).observe(el, { attributes: true, attributeFilter: ['open', 'disabled'], subtree: true });
    }
    function click(event) {
      const link = event.target?.closest?.('a[href]');
      if (!menuLink(link) || !normalClick(event, link)) return;
      const el = available();
      if (!el) return; // The native href remains the fallback if the selector did not load.
      attach(el);
      event.preventDefault();
      event.stopPropagation(); // Avoid a second native submenu click before selection.
      if (el.open) { sync(); return; }
      opener = link;
      const mobileNav = link.closest('.header__mobile-nav');
      const toggle = mobileNav?.querySelector('[data-action="toggle-menu"][aria-controls="mobile-menu"]');
      // Verified native MobileNavigation._toggleMenu owns scroll lock, panels and ARIA.
      if (toggle?.getAttribute('aria-expanded') === 'true') {
        toggle.click();
        opener = toggle;
      }
      try {
        const opening = win.FCSLiveFitment.openChooser();
        sync();
        if (el.open && !el.hasAttribute?.('data-fcs-mobile-panel')) reveal(el.querySelector('.fcs-finder__shell') || el);
        // openChooser handles lookup errors; this catches only unexpected opening failures.
        Promise.resolve(opening).catch(() => { if (!el.open) win.location.assign(link.href); });
      } catch (_) { if (!el.open) win.location.assign(link.href); }
    }
    function suppressNativeSubmenu(event) {
      const link = event.target?.closest?.('a[href]');
      // Warehouse treats any menuitem with aria-haspopup as a submenu and expects a sibling.
      if (menuLink(link) && available()) event.stopPropagation();
    }
    function refresh() { const el = available(); if (el) { attach(el); sync(); } }
    function install() {
      doc.addEventListener('click', click, true);
      doc.addEventListener('mouseover', suppressNativeSubmenu, true);
      doc.addEventListener('focusin', suppressNativeSubmenu, true);
      doc.addEventListener('shopify:section:load', refresh);
      refresh();
    }
    return { install, refresh, click, sync, menuLink, normalClick, suppressNativeSubmenu };
  }
  function installBackToTop(win, doc) {
    const existing = doc.querySelector('[data-fcs-back-to-top]');
    if (existing) return existing;
    const mobile = win.matchMedia('(max-width: 999px)');
    const button = doc.createElement('button');
    button.type = 'button'; button.className = 'fcs-back-to-top';
    button.dataset.fcsBackToTop = ''; button.hidden = true;
    button.setAttribute('aria-label', 'Back to top');
    const arrow = doc.createElement('span'); arrow.textContent = '↑'; arrow.setAttribute('aria-hidden', 'true');
    const label = doc.createElement('span'); label.textContent = 'Top';
    button.append(arrow, label); doc.body.append(button);
    const purchaseControls = new Set();
    const update = () => { button.hidden = !mobile.matches || purchaseControls.size > 0 || win.scrollY < Math.max(480, win.innerHeight * .75); };
    if (win.IntersectionObserver) {
      const observer = new win.IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) purchaseControls.add(entry.target); else purchaseControls.delete(entry.target); });
        update();
      }, { rootMargin: '12px' });
      doc.querySelectorAll('.product-form [data-action="add-to-cart"], .product-form .shopify-payment-button').forEach(node => observer.observe(node));
    }
    button.addEventListener('click', () => {
      const main = doc.querySelector('main');
      if (main) { if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1'); main.focus({ preventScroll: true }); }
      win.scrollTo({ top: 0, behavior: win.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    win.addEventListener('scroll', update, { passive: true });
    win.addEventListener('resize', update, { passive: true });
    mobile.addEventListener('change', update); update();
    return button;
  }
  if (typeof module === 'object' && module.exports) module.exports = { createVehicleMenu, createMobileVehiclePanel, installBackToTop };
  if (typeof window !== 'undefined' && typeof document !== 'undefined' && !window.FCSVehicleMenu) {
    const menu = createVehicleMenu(window, document);
    window.FCSVehicleMenu = menu;
    const install = () => { const panel = createMobileVehiclePanel(window, document); window.FCSMobileVehiclePanel = panel; panel.install(); menu.install(); installBackToTop(window, document); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
    else install();
  }
})();
